import { useState } from 'react';

import { PAGE } from './index';
import { backHoverIcon, backNormalIcon } from '../../assets/EditHeader';
import { useAppSelector } from '../../state';
import { track } from '../../track';
import { ENpcStatusTrackText } from '../Home';
import { getNpcStatus } from '../Home/NpcList';
import { LocalImage } from '../Image';

interface IBackButtonProps {
  styles: Record<string, string>;
  backUrl?: string;
}

export function BackButton({ styles, backUrl }: IBackButtonProps) {
  const [isHover, setHover] = useState(false);

  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);

  const { npcId, statusInfo } = useAppSelector((state) => state.edit);
  const status = getNpcStatus(statusInfo);

  const handleBack = () => {
    track.send('back_click', PAGE, {
      npc_id: npcId,
      ugc_npc_approving_status: ENpcStatusTrackText[status],
    });

    location.href = backUrl || '/create';
  };

  return (
    <div
      className={styles.backButton}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleBack}
    >
      <LocalImage
        width="32"
        height="32"
        alt="back icon"
        src={isHover ? backHoverIcon : backNormalIcon}
      />
    </div>
  );
}

export default BackButton;
